class Toggle {
    constructor() {
        /**
         * Обёртка
         */
        this.wrapper = null;

        /**
         * Кнопки для показа/скрытия контента
         * @type {array}
         */
        this.buttons = [];

        /**
         * Класс присваеваемый контенту для показа
         * @type {string}
         */
        this.activeDefaultClass = 'is-active';
    }

    /**
     * Инициализация компонента
     * @param {object} options - параметры
     */
    init(options) {
        this.wrapper = options.wrapper;
        this.activeClass = this.wrapper.dataset.activeClass || this.activeDefaultClass;

        if (!this.wrapper) {
            return;
        }

        this.buttons = Array.from(this.wrapper.querySelectorAll('.j-toggle-button'));

        this._bindEvents();
    }

    /**
     * Навешиваем обработчики событий
     * @private
     */
    _bindEvents() {
        if (!this.buttons || !this.buttons.length) {
            return;
        }

        this.buttons.forEach((button) => {
            button.addEventListener('click', () => {
                this._toggleContent();
            });
        });
    }

    /**
     * Скрывает/показывает контент
     * @private
     */
    _toggleContent() {
        this.wrapper.classList.toggle(this.activeClass);
    }
}

export default Toggle;
